// ═══════════════════════════════════════════════════════════════════════════
// 📦 Singleton instance do FirestoreManager
// ═══════════════════════════════════════════════════════════════════════════
//
// Uso:
//   import { getFirestoreService } from './services/firestoreService';
//   const fm = getFirestoreService();
//   const rits = await fm.getDocs('rits', [orderBy('createdAt', 'desc'), limit(50)]);

import FirestoreManager from './FirestoreManager';
import { initializeApp } from 'firebase/app';

let firestoreService = null;

/**
 * Inicializa o FirestoreManager com a app do Firebase
 * Deve ser chamado uma vez no bootstrap da aplicação
 */
export function initFirestoreService(firebaseApp) {
  if (!firestoreService) {
    firestoreService = new FirestoreManager(firebaseApp);
    console.log('✅ FirestoreService initialized');
  }
  return firestoreService;
}

/**
 * Retorna a instância singleton do FirestoreManager
 */
export function getFirestoreService() {
  if (!firestoreService) {
    throw new Error('FirestoreService not initialized. Call initFirestoreService() first.');
  }
  return firestoreService;
}

/**
 * Alias útil para acesso rápido
 */
export const fs = firestoreService;

export default FirestoreManager;
